// ----------------------------------------------------------------------------
// Nombre del Programa : NuevaSolicitud
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que se utiliza para la vista y funciones de una nueva solicitud de comunicado
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import { Button } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import useAutosizeTextArea from '../../../Utilidades/useAutosizeTextArea';
import { StatusAlertService } from 'react-status-alert';
import InputGroup from 'react-bootstrap/InputGroup';
import Simplert from 'react-simplert';
import {
  SolicitudComunicadosProps,
  TipoNecesidadProps,
  TipoMensajeProps,
} from '../../../interfaces/solicitudComunicadosInterfaces';
import { getSolicitudesNecesidades, getSolicitudesMensajes, postSolicitudes } from '../../../Services/SolicitudComunicadosService';

export const NuevaSolicitud = () => {
  const [nombreSolicito, setNombreSolicito] = useState('');
  const [areaSolicito, setAreaSolicito] = useState('');
  const [tiposNecesidad, setTiposNecesidad] = useState<TipoNecesidadProps[]>(
    []
  );
  const [tipoMensajes, setTipoMensajes] = useState<TipoMensajeProps[]>([]);
  const [necesidadSeleccionado, setNecesidadSeleccionado] = useState('0');
  const [mensajeSeleccionado, setMensajeSeleccionado] = useState('0');
  const [segmentoSeleccionado, setSegmentoSeleccionado] = useState(false);
  const [fechaComunicado, setFechaComunicado] = useState('');
  const [descripcionSolicitud, setDescripcionSolicitud] = useState('');
  const [nombreEnlace, setNombreEnlace] = useState('');
  const [mostrarAlerta, setMostrarAlerta] = useState<boolean>(false);

  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  useAutosizeTextArea(textAreaRef.current, descripcionSolicitud);

  const navigate = useNavigate();

  useEffect(() => {
    cargarTiposNecesidad();
    cargarMensajes();
  }, []);

  const cargarTiposNecesidad = async () => {
    const response: any = await getSolicitudesNecesidades().catch(({ response }) => {
      const { data } = response;
      const nodata: TipoNecesidadProps[] = [];
      setTiposNecesidad(nodata);
    });
    if (response.data && response.data.data) {
      setTiposNecesidad(response.data.data);
    }
  };
  const cargarMensajes = async () => {
    const response: any = await getSolicitudesMensajes().catch(({ response }) => {
      const { data } = response;
      const nodata: TipoMensajeProps[] = [];
      setTipoMensajes(nodata);
    });
    if (response.data && response.data.data) {
      setTipoMensajes(response.data.data);
    }
  };

  const enviarSolicitud = async () => {
    if (nombreSolicito === '') {
      StatusAlertService.showError('Ingrese el nombre');
      return;
    } else if (necesidadSeleccionado === '0') {
      StatusAlertService.showError('Seleccione el tipo de necesidad');
      return;
    }
    if (necesidadSeleccionado === '2') {
      if (mensajeSeleccionado === '0') {
        StatusAlertService.showError('Seleccione el tipo de mensaje');
        return;
      } else if (fechaComunicado === '') {
        StatusAlertService.showError('Seleccione la fecha');
        return;
      } else if (descripcionSolicitud === '') {
        StatusAlertService.showError('Ingrese la descripción');
        return;
      } else if (segmentoSeleccionado && nombreEnlace === '') {
        StatusAlertService.showError('Agregue el enlace');
        return;
      }
    }

    let solicitudComunicado = {} as SolicitudComunicadosProps;

    let tipoNecesidad = {} as TipoNecesidadProps;
    tipoNecesidad.tiponecesidad_id = Number(necesidadSeleccionado);

    solicitudComunicado.solicitudcomunicado_id = 0;
    solicitudComunicado.nombreSolicito = nombreSolicito;
    solicitudComunicado.areaSolicito = areaSolicito;
    solicitudComunicado.tiponecesidad_id = tipoNecesidad;

    if (necesidadSeleccionado === '2') {
      let tipoMensaje = {} as TipoMensajeProps;
      tipoMensaje.tipomensaje_id = Number(mensajeSeleccionado);
      solicitudComunicado.tipomensaje_id = tipoMensaje;
      solicitudComunicado.segmento = segmentoSeleccionado;
      solicitudComunicado.urlEnlaceSegmento = segmentoSeleccionado
        ? nombreEnlace
        : '';
      solicitudComunicado.fechaMensaje =
        moment(fechaComunicado).format('YYYY-MM-DD') + ' 00:00:00.00';
      solicitudComunicado.descripcion = descripcionSolicitud;
      //solicitudComunicado.fechaPublicacion = moment(new Date()).format("YYYY-MM-DD");
    }

    const response: any = await postSolicitudes(solicitudComunicado).catch(({ response }) => {
      const { data } = response;
      StatusAlertService.showError(data.meta.message);
    });
    if (response.data && response.data.data) {
      //navigate(-1);
      setMostrarAlerta(true);
    }
  };

  const cerrarSolicitud = () => {
    navigate(-1);
  };

  const enterTexto = (target: any) => {
    if (target.key === 'Enter') {
      target.preventDefault();
    }
  };
  return (
    <>
      <Simplert
        showSimplert={mostrarAlerta}
        type="info"
        title="Solicitud Recibida"
        message="En breve te contactaremos para dar seguimiento."
        customCloseBtnText="Entendido"
        customCloseBtnClass="btn-cerrar"
        disableOverlayClick={true}
        useConfirmBtn={false}
        onClose={() => cerrarSolicitud()}
      />
      <div>
        <Row className="mt-3 agregar-usuario">
          <Col>
            <Row className="titulo">
              <Col className="heading-1">Nueva Solicitud</Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <Form.Label>¿Cuál es tu nombre?</Form.Label>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder=""
                    aria-label="Search"
                    value={nombreSolicito}
                    onKeyPress={enterTexto}
                    maxLength={100}
                    onChange={(e) => setNombreSolicito(e.target.value)}
                    className="borde-rojo"
                  />
                </Form>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={12} className="minimocolumna">
                <Form.Label>¿Cuál es tu área?</Form.Label>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder=""
                    aria-label="Search"
                    value={areaSolicito}
                    onKeyPress={enterTexto}
                    maxLength={100}
                    onChange={(e) => setAreaSolicito(e.target.value)}
                    className="borde-rojo"
                  />
                </Form>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={4} className="minimocolumna">
                <Form.Label>Tipo de Necesidad</Form.Label>
                <Form className="d-flex">
                  <Form.Select
                    className="borde-rojo"
                    value={necesidadSeleccionado}
                    onChange={(e) => setNecesidadSeleccionado(e.target.value)}
                  >
                    <option value="0">Elige una opción</option>
                    {tiposNecesidad.length > 0 ? (
                      tiposNecesidad.map((necesidad, index) => (
                        <option
                          key={necesidad.tiponecesidad_id}
                          value={necesidad.tiponecesidad_id}
                        >
                          {necesidad.nombre}
                        </option>
                      ))
                    ) : (
                      <option value="0"></option>
                    )}
                  </Form.Select>
                </Form>
              </Col>
            </Row>
            {necesidadSeleccionado === '2' ? (
              <div>
                <Row className="mt-3">
                  <Col sm={12} className="minimocolumna">
                    <Form.Label>
                      ¿Como consideras el tipo de mensaje que deseas comunicar?
                    </Form.Label>
                  </Col>
                </Row>
                <Row>
                  <Col sm={4} className="minimocolumna">
                    <Form className="d-flex">
                      <Form.Select
                        className="borde-rojo"
                        value={mensajeSeleccionado}
                        onChange={(e) => setMensajeSeleccionado(e.target.value)}
                      >
                        <option value="0">Tipo de Mensaje</option>
                        {tipoMensajes.length > 0 ? (
                          tipoMensajes.map((tipomensaje, index) => (
                            <option
                              key={tipomensaje.tipomensaje_id}
                              value={tipomensaje.tipomensaje_id}
                            >
                              {tipomensaje.nombre}
                            </option>
                          ))
                        ) : (
                          <option value="0"></option>
                        )}
                      </Form.Select>
                    </Form>
                  </Col>
                  <Col sm={8} className="minimocolumna">
                    {tipoMensajes.length > 0 ? (
                      tipoMensajes.map((tipomensaje, index) => (
                        <Col
                          key={tipomensaje.tipomensaje_id}
                          sm={12}
                          className="minimocolumna"
                        >
                          <Form.Label className="textonegro">
                            *{tipomensaje.nombre}:
                          </Form.Label>{' '}
                          <span>{tipomensaje.descripcion}</span>
                        </Col>
                      ))
                    ) : (
                      <Form.Label className="textonegro"></Form.Label>
                    )}
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col sm={12} className="minimocolumna">
                    <Form.Label>
                      ¿A quién va dirigido el mensaje que quieres lanzar?
                    </Form.Label>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} className="minimocolumna">
                    <Form className="d-flex">
                      <Form.Check
                        inline
                        label="Todo PROSA"
                        name="group1"
                        type="radio"
                        className="radiosegmento"
                        checked={!segmentoSeleccionado}
                        onChange={(e) => setSegmentoSeleccionado(false)}
                      />
                      <Form.Check
                        inline
                        label="Un segmento especifico de usuarios"
                        name="group1"
                        type="radio"
                        className="radiosegmento"
                        onChange={(e) => setSegmentoSeleccionado(true)}
                      />
                    </Form>
                  </Col>
                </Row>
                {segmentoSeleccionado ? (
                  <Row className="mt-3">
                    <Col sm={12}>
                      <label></label>
                      <Form className="d-flex">
                        <InputGroup.Text className="material-icons icono-enlace borde-rojo">
                          link
                        </InputGroup.Text>
                        <Form.Control
                          type="search"
                          className="texto-enlace borde-rojo"
                          placeholder="Agregar enlace."
                          value={nombreEnlace}
                          onChange={(e) => setNombreEnlace(e.target.value)}
                          onKeyPress={enterTexto}
                        />
                      </Form>
                    </Col>
                  </Row>
                ) : (
                  ''
                )}
                <Row className="mt-3">
                  <Col sm={12} className="minimocolumna">
                    <Form.Label>
                      ¿En qué fecha debemos enviar el mensaje?
                    </Form.Label>
                  </Col>
                </Row>
                <Row>
                  <Col sm={4} className="minimocolumna">
                    <Form.Control
                      type="date"
                      name="datepicd"
                      placeholder="Desde"
                      className="borde-rojo"
                      min={moment(new Date().toString()).format('YYYY-MM-DD')}
                      value={fechaComunicado}
                      onChange={(e) => setFechaComunicado(e.target.value)}
                    />
                    <label>
                      Considera los tiempos que toma el proceso de aprobación
                    </label>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col sm={12} className="minimocolumna">
                    <Form className="d-flex">
                      <textarea
                        disabled={false}
                        onChange={(e) =>
                          setDescripcionSolicitud(e.target.value)
                        }
                        ref={textAreaRef}
                        rows={1}
                        value={descripcionSolicitud}
                        maxLength={3900}
                        placeholder="Describe la idea del mensaje que necesitas comunicar..."
                        className="textoauto"
                      />
                    </Form>
                  </Col>
                </Row>
              </div>
            ) : (
              ''
            )}
            <div className="d-flex flex-row-reverse bd-highlight mt-3">
              <Button
                variant="primary"
                className="float-end"
                onClick={() => enviarSolicitud()}
              >
                Enviar Solicitud
              </Button>
              <Button
                variant="secondary"
                className="float-end me-3"
                onClick={() => navigate(-1)}
              >
                Cancelar
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
